<template>
    <v-layout class="mission-container" column>                 
      <router-view/>
    </v-layout>
</template>
<script>
  import { mapGetters } from 'vuex'
  import MissionState from '@/components/mission/MissionState'
  export default {
    name: 'CacheGraphs',          
    components:{MissionState},
    computed:{
      ...mapGetters([
         'detailMissions'
      ])
    },
    methods:{
    },
    watch:{
      detailMissions(newValue){
        //si l'onglet fermé est l'onglet en cours on navigue sur la page précédente        
        if(this.$route.params.missionid && 
          newValue.findIndex(it => it.mission.misId == this.$route.params.missionid) == -1
        ) {          
          this.$router.push('/pilot/mission/'+(newValue.length > 0?newValue[0].mission.misId:""))
        }        
      }
    }
  }
</script>

<style scoped>
  .mission-container{    
    position: absolute;
    top: 0; bottom: 0; left: 0; right: 0;
    overflow: hidden;
  }
  .missiontab, .missionmore{
    border-right:1px solid #efefef;
  }
  .missiontab  .v-tabs__item{
    padding-right: 0;
  }   
  
</style>

<style>
  .missiontab .v-tabs__item--active,.missionmore .v-tabs__item--active{
    background-color:#ddd;
  }
  
</style>